import React from "react";
import DrawerComponent from "../components/DrawerComponent";
function DrawerContainer() {
  const handleClick = (e) => {
    console.log(e.clientX, e.clientY);
  };
  return <DrawerComponent onClick={handleClick} />;
}

export default DrawerContainer;
